import _ from 'lodash';
import calcProductsInUse from './calcProductsInUse';

const _sort = (a, b) =>
  a.localeCompare(b, undefined, { sensitivity: 'accent' });

export const MINIMUM_SEARCH_LENGTH = 3;

export const getProductName = product => {
  return product?.name ?? product?.productName;
};
export const getManufacturerName = product => {
  return product?.manufacturer ?? product?.manufacturerName;
};
export const getProductType = product => {
  return product?.producttype ?? product?.type ?? product?.productType;
};
export const getProductStandardUnit = product => {
  return product?.stdunit ?? product?.stdUnit;
};
export const getRegistrationNumber = product => {
  return product?.registrationnumber ?? product?.registrationNumber;
};

const filteredProducts = (searchResults, searchText) => {
  // Add safety check for searchResults
  if (!searchResults || !Array.isArray(searchResults)) {
    return [];
  }

  const searchTextLowerCase = searchText.toLowerCase();
  const setsFiltered = {
    category1: [],
    category2: [],
    category3: [],
    category4: []
  };
  searchResults.forEach(product => {
    const productNameLowerCase = (getProductName(product) ?? '').toLowerCase();
    const manufacturerLowerCase = (
      getManufacturerName(product) ?? ''
    ).toLowerCase();

    if (productNameLowerCase.startsWith(searchTextLowerCase)) {
      setsFiltered.category1.push(product);
    } else if (productNameLowerCase.includes(searchTextLowerCase)) {
      setsFiltered.category2.push(product);
    } else if (manufacturerLowerCase.startsWith(searchTextLowerCase)) {
      setsFiltered.category3.push(product);
    } else if (manufacturerLowerCase.includes(searchTextLowerCase)) {
      setsFiltered.category4.push(product);
    }
  });
  const filteredResultsSorted = [
    setsFiltered.category1
      .slice()
      .sort((a, b) => _sort(getProductName(a), getProductName(b))),
    setsFiltered.category2
      .slice()
      .sort((a, b) => _sort(getProductName(a), getProductName(b))),
    setsFiltered.category3
      .slice()
      .sort((a, b) => _sort(getManufacturerName(a), getManufacturerName(b))),
    setsFiltered.category4
      .slice()
      .sort((a, b) => _sort(getManufacturerName(a), getManufacturerName(b)))
  ];

  const flattenedResults = _.flatMap(filteredResultsSorted);
  return flattenedResults;
};

export const getFilteredSearchProducts = ({
  productsInUse,
  searchedProducts,
  typeFilters,
  searchText,
  myProducts,
  showProductList
}) => {
  if (searchText.length < MINIMUM_SEARCH_LENGTH) return [];
  let searchResults = filteredProducts(
    calcProductsInUse(productsInUse, searchedProducts, []),
    searchText
  );

  if (typeFilters?.includes('CustomProduct')) {
    searchResults = searchResults.filter(product => product.custom === true);
  } else if (typeFilters?.length) {
    searchResults = searchResults.filter(product =>
      typeFilters
        .map(producttype => producttype?.toUpperCase())
        .includes(getProductType(product).toUpperCase())
    );
  }

  if (myProducts?.length && showProductList) {
    searchResults = searchResults.filter(
      prod => !myProducts.find(myProd => myProd.productId === prod.id)
    );
  }
  return searchResults;
};

export default filteredProducts;
